import { Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { Image } from '@bfe/moly';
import { CloseIcon } from '@bfe/moly-icons';
import { absoluteToRelative } from '@web3/base-utils';
import { Page } from '@/config/track-config';

type NoWinProps = {
  onClick: () => void;
};

const url = absoluteToRelative(
  'https://fh-static.bycsi.com/draw-failed-4f771a29225aeda64581e9615bbc08d0.png'
);

export const NoWin = ({ onClick }: NoWinProps) => {
  const fm = useFm();

  return (
    <div className="relative flex flex-col items-center justify-center pt-14">
      <CloseIcon
        onClick={onClick}
        className={
          'absolute top-0 right-10 cursor-pointer w-6 h-6 text-gray-400'
        }
      />

      <Image className="w-50 h-50" src={url} alt="no win" />
      <p className="max-w-[440px] mt-8 text-gray1 text-2xl font-semibold text-center">
        {fm('betterLuckNextTime')}
      </p>
      <div className="relative flex flex-col items-center mt-8">
        <Button
          className="w-[320px] !h-[48px]"
          key="confirm"
          variant="primary"
          onClick={onClick}
          data-spm-even="Web3UserClick"
          data-spm-data={JSON.stringify({
            page_name: Page.RewardsPage,
            button_name: 'Web3Points_Close',
          })}
        >
          {fm('close')}
        </Button>
      </div>
    </div>
  );
};
